;(function () {
  'use strict'

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  const DATA_SELECTOR$1 = 'data-fancybox'

  /**
   * ------------------------------------------------------------------------
   * Functions - Public
   * ------------------------------------------------------------------------
   */

  const fancyboxGeneral = () => {
    let FANCYBOX = `a[${DATA_SELECTOR$1}]`

    $(FANCYBOX).fancybox({
      buttons: [
        'slideShow',
        'thumbs',
        'zoom',
        'close'
      ],
    })

    document.querySelectorAll("#privary-navigation .fancybox").forEach(element => element.setAttribute('data-fancybox',""));
  }

  /**
   * ------------------------------------------------------------------------
   * DOM Content Loaded is ready available
   * @param {*} callback
   * ------------------------------------------------------------------------
   */
  const onDOMLoaded = (callback) => {
    if (
      document.readyState === 'complete' ||
      document.readyState === 'interactive'
    ) {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(callback, 1)
      })
    } else {
      document.addEventListener('DOMContentLoaded', callback)
    }
  }

  onDOMLoaded(fancyboxGeneral())
})()
